<template lang="pug">
section.brand__section
  .brand__container
    .brand__item
      img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/brands/antm@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/antm.png 1x')
    .brand__item
      img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/brands/bbdo@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/bbdo.png 1x')
    .brand__item
      img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/brands/espn@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/espn.png 1x')
    .brand__item
      img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/brands/facebook@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/facebook.png 1x')
    .brand__item
      img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/brands/hbo@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/hbo.png 1x')
    .brand__item
      img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/brands/instagram@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/instagram.png 1x')
    .brand__item
      img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/brands/lincoln@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/lincoln.png 1x')
    .brand__item
      img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/brands/marriott@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/marriott.png 1x')
    .brand__item
      img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/brands/mashable@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/mashable.png 1x')
    .brand__item
      img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/brands/mccann@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/mccann.png 1x')
    .brand__item
      img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/brands/mercedes@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/mercedes.png 1x')
    .brand__item
      img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/brands/microsoft@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/microsoft.png 1x')
    .brand__item
      img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/brands/panasonic@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/panasonic.png 1x')
    .brand__item
      img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/brands/pepsi@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/pepsi.png 1x')
    .brand__item
      img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/brands/ted@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/ted.png 1x')
  .marketingBadge
    a(href="https://www.facebook.com/business/solutions-explorer/creative_platform/2160199024257586/Flixel")
      img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/brands/fbMarketing@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/fbMarketing.png 1x' alt='Facebook Marketing Partner')
</template>

<script>
export default {
  name: 'brands',
  mounted() {
    const myLazyLoad = new LazyLoad({
      elements_selector: 'iframe, .lazy',
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Brands.vue